module.exports = __webpack_public_path__ + "static/img/Videoamp-Default.b73f583.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/Videoamp-Default.png
// module id = 1781
// module chunks = 0